import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { useDrawerContext } from 'ui-components/components/drawer/context';

import messages from './messages';
// @ts-expect-error less import
import style from './style.module.less';

/**
 * @typedef {import('../../../../../prop-types/rate-shopper').RateShopper} RateShopper
 * @typedef {import('../../../../../prop-types/rate-shopper-carrier-service').RateShopperCarrierService} RateShopperCarrierService
 */

/**
 * @param {object} props
 * @param {boolean} [props.disabled]
 * @param {() => void} props.onSaveShopper
 * @param {RateShopper} props.shopper
 * @param {RateShopperCarrierService[]} props.unsavedServices
 * @returns {JSX.Element}
 */
export const PublishNewShopperButton = ({ disabled = false, onSaveShopper, shopper, unsavedServices }) => {
  const isSaveDisabled = disabled || unsavedServices.length === 0 || !shopper.name?.length;
  const { onClose } = useDrawerContext();

  return (
    <div className={style['edit-shopper-buttons']}>
      <Button onClick={onClose} theme='link'>
        <FormattedMessage {...messages.cancelEditShopperButtonText} />
      </Button>
      <Button disabled={isSaveDisabled} onClick={onSaveShopper} theme='primary'>
        <FormattedMessage {...messages.publishNewShopperButtonText} />
      </Button>
    </div>
  );
};
